<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex md6 xs12>
        <v-card>
          <v-card-title class="subheading">
            {{ textButtonFichar }}
            <v-spacer></v-spacer>
          </v-card-title>

          <v-container grid-list-xs>
            <v-form ref="form" v-model="valid" lazy-validation v-if="!finFichajes">
              <v-layout wrap ma-4 mt-0>
                <v-flex md12 sm12 v-if="conIncidencia">
                  <v-select
                    prepend-icon="location_city"
                    :items="incidencias"
                    v-model="incidenceTypeId"
                    item-text="text"
                    item-value="incidenceTypeId"
                    label="Incidencia"
                    :rules="incidenciaRules"
                    required
                  ></v-select>
                </v-flex>

                <v-flex md12 sm12>
                  <v-text-field
                    prepend-icon="how_to_reg"
                    readonly
                    v-model="usuario"
                    label="Usuario"
                    hint="Nombre del usuario que realiza el fichaje"
                  ></v-text-field>
                </v-flex>
                <v-flex md12 sm12>
                  <v-text-field
                    prepend-icon="access_time"
                    readonly
                    v-model="fechaActual"
                    label="Fecha/Hora"
                    hint="Fecha/Hora que se realizará el fichaje"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <btn-largo
                    :text="textButtonFichar"
                    fontColor="white--text"
                    color="white--text"
                    :bgcolor="bgColor"
                    v-if="!loading"
                    @click.native="submit"
                  ></btn-largo>

                  <btn-largo
                    text="Cancelar fichaje"
                    fontColor="white--text"
                    color="white--text"
                    bgcolor="blue-grey lighten-1"
                    v-if="loading"
                    @click.native="cancelar"
                  ></btn-largo>
                </v-flex>
                <v-progress-linear v-if="loading" :value="timeProgress"></v-progress-linear>
              </v-layout>
            </v-form>
            <v-alert type="success" v-if="finFichajes">
              Se ha registrado correctamente el fichaje con fecha:
              <strong>{{ fechaFichajeReal }}</strong>
              <v-divider class="my-4 success" style="opacity: 0.22"></v-divider>
              <v-row align="center" no-gutters>
                <v-col class="grow"></v-col>
                <v-spacer></v-spacer>
                <v-col class="shrink">
                  <v-btn color="white" elevation="0" outlined @click="goHome">Volver</v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex md6 xs12 v-if="isSmAndUp">
        <ultimos-fichajes ref="ultFichaje"></ultimos-fichajes>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import btnLargo from "@/components/commons/btnLargo";
import ultimosFichajes from "@/components/fichajes/ultimosFichajes";
import fechaHoraServerServices from "@/services/fechaHoraServerServices.js";
import fichajeServices from "@/services/fichajeServices.js";
import tipoIncidenciaServices from "@/services/tipoIncidenciaServices.js";

const moment = require("moment");
require("moment/locale/es");

export default {
  props: {
    conIncidencia: {
      type: Boolean,
      default: false
    },
    textButtonFichar: {
      type: String,
      default: "Fichar"
    },
    bgColor: {
      type: String,
      default: "teal"
    }
  },
  components: {
    btnLargo,
    ultimosFichajes
  },
  created() {
    this.$store.commit("global/SET_MIGA", [
      { text: "Inicio", href: "/" },
      { text: "Fichar", href: "/fichar" }
    ]);

    this.$getLocation().then(coordinates => {
      console.log(coordinates);
      this.latitude = coordinates.lat;
      this.longitude = coordinates.lng;
      this.accuracy = coordinates.accuracy;
    });
  },
  mounted() {
    var that = this;
    that.fechaActual = moment().format(this.getFormatoFechaToView);
    that.getDateTimeServer();

    this.intervaloFechaSrv = setInterval(function() {
      that.getDateTimeServer();
    }, 4000);

    that.intervaloFechaCli = setInterval(function() {
      that.incrementaFechaLocal();
    }, 1000);

    that.intervaloFechaReload = setInterval(function() {
      location.reload();
    }, 60000 * 2); //2 minutos

    if (this.conIncidencia) {
      this.obtenerTiposIncidencias();
    }
  },
  beforeDestroy() {
    var that = this;
    if (!!that.intervaloFechaSrv) clearInterval(that.intervaloFechaSrv);
    if (!!that.intervaloFechaCli) clearInterval(that.intervaloFechaCli);
    if (!!that.intervaloFechaReload) clearInterval(that.intervaloFechaReload);
  },
  data() {
    return {
      fechaFichajeReal: null,
      latitude: null,
      longitude: null,
      accuracy: null,
      intervaloFechaCli: null,
      intervaloFechaSrv: null,
      intervaloFechaReload: null,
      loading: false,
      fechaActual: "",
      fechaActualUTC: "",
      varTimeOut: null,
      varTimeOutProgress: null,
      timeProgress: 0,
      valid: false,
      //formatDate: "DD/MM/YYYY HH:mm:ss",
      finFichajes: false,
      incidencias: [],
      incidenceTypeId: null,
      incidenciaRules: [v => !!v || "La incidencia es requerida"]
    };
  },
  computed: {
    ...mapState("global", ["tiempoFichaje"]),
    usuario: function() {
      return this.user.displayName;
    },
    user: function() {
      return this.$store.state.authentication.user;
    },
    isSmAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    },
    tiempoFichajeMs: function(){
      return this.tiempoFichaje * 1000;
    },
    tiempoFichajeMsPorc025: function(){
      return this.tiempoFichajeMs * 0.025;
    },
    factorIncremento: function(){
      return (this.tiempoFichajeMsPorc025 /  this.tiempoFichajeMs) * 100;
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    getDateTimeServer() {
      fechaHoraServerServices.getFechaHoraActualServer().then(res => {
        this.fechaActualUTC = moment.utc(res);
        this.fechaActual = moment
          .utc(res)
          .local()
          .format(this.getFormatoFechaToView);
      });
    },
    incrementaFechaLocal() {
      this.fechaActualUTC = moment.utc(this.fechaActualUTC).add(1, "seconds");
      this.fechaActual = moment(this.fechaActual, this.getFormatoFechaToView)
        .add(1, "seconds")
        .format(this.getFormatoFechaToView);
    },
    obtenerTiposIncidencias() {
      tipoIncidenciaServices.getTipos().then(res => {
        this.incidencias = res;
      });
    },
    submit: function() {
      var that = this;
      if (this.$refs.form.validate()) {
        this.loading = true;
        var that = this;
        //YYYY-MM-DDTHH:MI:SS.sssZ
        this.timeProgress = 0;

        /*
        this.varTimeOutProgress = setInterval(function() {
          that.timeProgress = that.timeProgress + 2.5;
        }, 250);
        */

        this.varTimeOutProgress = setInterval(function() {
          that.timeProgress = that.timeProgress + that.factorIncremento;
        }, that.tiempoFichajeMsPorc025);
        this.varTimeOut = setTimeout(function() {
          clearTimeout(this.varTimeOutProgress);
          var datFichaje = {
            employeeId: that.user.employeeId,
            customerId: that.user.customerId,
            fecha: moment
              .utc(that.fechaActualUTC)
              .local()
              .format(that.getFormatoFechaToServer),
            incidenceTypeId: that.conIncidencia ? that.incidenceTypeId : null,
            userId: that.user.userId,
            latitude: that.latitude,
            longitude: that.longitude,
            accuracy: that.accuracy
          };
          fichajeServices.fichar(datFichaje).then(res => {
            if (!!res && !!res.markId) {
              that.loading = false;
              that.finFichajes = true;
              that.fechaFichajeReal = moment
                .utc(res.markDateTime)
                .local()
                .format(that.getFormatoFechaToView);
            }
            that.$refs.ultFichaje.obtenerUltimosFichajes();
            console.log(res);
          });
        }, that.tiempoFichajeMs);
      }
    },
    cancelar: function() {
      clearTimeout(this.varTimeOutProgress);
      clearTimeout(this.varTimeOut);
      this.loading = false;
    },
    getNow: function() {
      const today = new Date();
      const date =
        today.getDate() +
        "/0" +
        (today.getMonth() + 1) +
        "/" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      this.fechaActual = dateTime;
    }
  }
};
</script>
